export enum ProjectConfigCategories {
  Properties = 'Properties',
}

export enum PropertiesColumns {
  Selected = 'Selected',
  Label = 'Label',
  Message = 'Message',
}

export enum PropertyType {
  List = 'list',
  Number = 'number',
  String = 'string',
}

export enum PropertyEntityType {
  Assets = 'Assets',
  Geofences = 'Geofences',
}
